import { scrollAnimation } from './function/scroll-animation.js';
const slick = require('/assets/js/lib/slick/slick.js');
import '/assets/js/common.js';
import '/assets/js/lib/slick/slick.css';
import '/assets/css/common.scss';
import '/assets/css/facility-detail.scss';

// ===========================================
// パートナーのスライドショー
// ===========================================
$(function () {
  $('.slideShowArea .slideShowList').each(function(){
    const slide = $(this);

    slide.slick({
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      slidesToShow: 1,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 30000,
    });
  });
});